import {observable, computed} from 'mobx';
import {VIDEO_MODES} from '../../../../states/dashboard/main/main.settings';
import {serializable} from 'serializr';
export default class VideoModeState {
    @observable isMicrophoneMuted: boolean = false;

    @observable isSupportAudio: boolean = false;

    @observable isAudioStreamConnected: boolean = false;

    @observable isActive: boolean = false;

    @observable isVideoControlActive: boolean = false;

    @observable readonly videoState: VideoState = new VideoState();

    @observable private _preloadedImage: any | undefined = undefined;

    @computed
    get preloadedImage(): any | undefined {
        return this._preloadedImage;
    }

    set preloadedImage(value: any | undefined) {
        // In MobX 4, @observable automatically makes assigned objects observable
        // But we can be explicit to ensure nested properties are tracked
        this._preloadedImage = value;
    }

    @observable wasInVideoMode: boolean = false;
}

export class VideoState {
    @observable enabled: boolean = false;
    @observable mode: string | undefined = undefined;
    @observable focus: boolean | undefined = undefined;
    @observable isClientVisible: boolean | undefined = undefined;
    @observable sizeTarget: string | undefined;
    @observable accountId: string | undefined = undefined;
    @observable videoFormatResolution: any = null;
    @observable roomId: string | undefined = undefined;
    @observable enableDashboardMagicMarker: boolean | undefined = undefined;
    @observable enableCustomerMagicMarker: boolean | undefined = undefined;
    @observable magicMarker: any | undefined = undefined;
    @observable isPaused: boolean | undefined = undefined;
    @observable videoPausedByDashboard: boolean | undefined = undefined;
    @observable isLivePointerOnMobileDashboardEnabled: boolean | undefined = undefined;
    @observable remoteControl: boolean | undefined = undefined;
    @observable MODES: typeof VIDEO_MODES = VIDEO_MODES;
    @observable isVideoStreamPlaying: boolean = false;

    @computed
    get isCursorSharingActive(): boolean {
        return !!(this.focus && this.mode === this.MODES?.CURSOR_SHARING && this.isVideoStreamPlaying);
    }
}
